/**
 * Action configs for thread comments. Pass one of these as `commentActions` to
 * CommentsSection/CommentsList along with `commentParams` so they stay
 * context-agnostic (no branching on "progress-photo" vs "exercise-video-list").
 */

export const exerciseVideoListCommentActions = {
  add: {
    url: "/actions/exercise/add-video-thread-comment",
    buildBody: (params, { message, senderId, receiverId }) => ({
      threadId: params.threadId,
      message,
      senderId,
      ...(receiverId != null && { receiverId }),
      ...(!params.threadId && {
        setIndex: params.setIndex,
        videoIndex: params.videoIndex,
        exerciseId: params.exerciseId,
      }),
      activityContext: {
        threadContext: "exercise-video",
        exerciseId: params.exerciseId,
        setIndex: params.setIndex,
        videoIndex: params.videoIndex,
        utcDate: params.utcDate,
        threadId: params.threadId,
        ...(params.primary != null && { primary: params.primary }),
        ...(params.secondary != null && { secondary: params.secondary }),
        ...(params.type != null && { type: params.type }),
        ...(params.movement != null && { movement: params.movement }),
      },
    }),
  },
  delete: {
    url: (commentId) =>
      `/actions/exercise/delete-video-thread-comment/${commentId}`,
    buildBody: (params, { fullDelete }) => ({
      fullDelete,
      exerciseId: params.exerciseId,
      setIndex: params.setIndex,
      videoIndex: params.videoIndex,
      threadId: params.threadId,
    }),
  },
  edit: {
    url: "/actions/exercise/edit-video-thread-comment",
    buildBody: (_params, { commentId, message }) => ({ commentId, message }),
  },
};

export const progressPhotoCommentActions = {
  add: {
    url: "/actions/daily-stats/progress-photos/add-thread-comment",
    buildBody: (params, { message, senderId, receiverId }) => ({
      threadId: params.threadId,
      message,
      senderId,
      ...(receiverId != null && { receiverId }),
      ...(!params.threadId && {
        dailyStatId: params.dailyStatId,
        photoType: params.photoType,
      }),
      activityContext: {
        threadContext: "body-photo",
        dailyStatId: params.dailyStatId,
        photoType: params.photoType,
        utcDate: params.utcDate,
      },
    }),
  },
  delete: {
    url: (commentId) =>
      `/actions/daily-stats/progress-photos/delete-thread-comment/${commentId}`,
    buildBody: (params, { fullDelete }) => ({
      fullDelete,
      threadId: params.threadId,
      photoType: params.photoType,
      dailyStatId: params.dailyStatId,
    }),
  },
  edit: {
    url: "/actions/daily-stats/progress-photos/edit-thread-comment",
    buildBody: (_params, { commentId, message }) => ({ commentId, message }),
  },
};

export const mealPhotoCommentActions = {
  add: {
    url: "/actions/daily-stats/meal-photos/add-thread-comment",
    buildBody: (params, { message, senderId, receiverId }) => ({
      threadId: params.threadId,
      message,
      senderId,
      ...(receiverId != null && { receiverId }),
      ...(!params.threadId && {
        mealPhotoId: params.mealPhotoId,
        athleteId: params.athleteId,
        mealType: params.mealType,
        date: params.date,
      }),
      activityContext: {
        threadContext: "meal-photo",
        dailyStatId: params.dailyStatId,
        mealType: params.mealType,
        mealPhotoId: params.mealPhotoId,
        utcDate: params.utcDate,
        threadId: params.threadId,
      },
    }),
  },
  delete: {
    url: (commentId) =>
      `/actions/daily-stats/meal-photos/delete-thread-comment/${commentId}`,
    buildBody: (params, { fullDelete }) => ({
      fullDelete,
      threadId: params.threadId,
      ...(fullDelete && {
        mealPhotoId: params.mealPhotoId,
        athleteId: params.athleteId,
        date: params.date,
        mealType: params.mealType,
        threadId: params.threadId,
      }),
    }),
  },
  edit: {
    url: "/actions/daily-stats/meal-photos/edit-thread-comment",
    buildBody: (_params, { commentId, message }) => ({ commentId, message }),
  },
};

export const videoCommentActions = {
  add: {
    url: "/actions/coach-videos/add-thread-comment",
    buildBody: (params, { message, senderId, receiverId }) => ({
      threadId: params.threadId,
      message,
      senderId,
      ...(receiverId != null && { receiverId }),
      ...(!params.threadId && {
        videoRecordId: params.videoRecordId,
      }),
      activityContext: {
        threadContext: "coach-video",
        videoRecordId: params.videoRecordId,
        utcDate: params.utcDate,
        threadId: params.threadId,
      },
    }),
  },
  delete: {
    url: (commentId) =>
      `/actions/coach-videos/delete-thread-comment/${commentId}`,
    buildBody: (params, { fullDelete }) => ({
      fullDelete,
      threadId: params.threadId,
      ...(fullDelete && {
        videoRecordId: params.videoRecordId,
        threadId: params.threadId,
      }),
    }),
  },
  edit: {
    url: "/actions/coach-videos/edit-thread-comment",
    buildBody: (_params, { commentId, message }) => ({ commentId, message }),
  },
};
